export default __webpack_public_path__ + "static/media/demand-response.bf4aa2b4.mp4";